// Site managed hosts (N), keyed by bare site_slug + host_slug:
//   GET|POST            /api/v1/sites/{site_slug}/hosts
//   GET|PUT|DELETE      /api/v1/sites/{site_slug}/hosts/{host_slug}

import { request, type ApiResponse } from "../client";
import type { HostConfig, HostCreateIn, HostUpdateIn } from "../types/siteHost";

const base = (s: string) => `/api/v1/sites/${encodeURIComponent(s)}/hosts`;
const one = (s: string, h: string) => `${base(s)}/${encodeURIComponent(h)}`;

export const siteHosts = {
  list: (siteSlug: string): Promise<ApiResponse<HostConfig[]>> =>
    request<HostConfig[]>("GET", base(siteSlug)),
  get: (siteSlug: string, hostSlug: string): Promise<ApiResponse<HostConfig>> =>
    request<HostConfig>("GET", one(siteSlug, hostSlug)),
  create: (siteSlug: string, body: HostCreateIn): Promise<ApiResponse<HostConfig>> =>
    request<HostConfig>("POST", base(siteSlug), body),
  update: (siteSlug: string, hostSlug: string, body: HostUpdateIn): Promise<ApiResponse<HostConfig>> =>
    request<HostConfig>("PUT", one(siteSlug, hostSlug), body),
  remove: (siteSlug: string, hostSlug: string): Promise<ApiResponse<void>> =>
    request<void>("DELETE", one(siteSlug, hostSlug)),
};
